export const currencyFormat = (value: number, currencyCode: string) =>
  new Intl.NumberFormat('en', {
    currency: currencyCode !== "" ? currencyCode : 'ZAR',
    currencyDisplay: 'narrowSymbol',
    style: 'currency'
  }).format(value);

export const dateTimeFormat = (value: Date,) =>
  new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).format(value);

export const dateFormat = (value: Date,) =>
  new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(value);

export const timeDateFormat = (value: Date,) =>
  new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).format(value);

  export const dateFormatYYYYMMDD = (date: Date) => {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }